import { useState } from 'react';
import { TimeChoice } from '../agenda/TimeChoice';
import { useAgendaDay } from '../agenda/useAgendaDay';
import { Spinner } from '../../ui/Spinner';
import { btnGhost, btnPrimary } from '../ui/styles';
import { dayLong, today } from '../../core/format/dates';
type Props = {
  durationMinutes: number;
  /** De afspraak die verzet wordt: botst niet met zichzelf. */
  ignoreId?: string;
  confirmLabel: (when: string) => string;
  busy: boolean;
  onConfirm: (date: string, time: string) => void;
  onCancel: () => void;
  /** Krijgt de gekozen dag en tijd mee, zodat de ouder er een vaste requestId van kan maken. */
  onChange?: (date: string, time: string) => void;
};

/**
 * De tijdkiezer van de agenda (`TimeChoice`) in het klantdossier: zelfde vrije tijden, met
 * behandelduur, opruimtijd en vakantiedagen. Alleen vrije tijden: deze verzoeken kennen geen
 * `allowOverlap`. Over iets heen plannen doe je in de agenda zelf.
 */
export function CustomerTimeChoice({
  durationMinutes,
  ignoreId,
  confirmLabel,
  busy,
  onConfirm,
  onCancel,
  onChange
}: Props) {
  const [date, setDate] = useState(today());
  const [time, setTime] = useState('');
  const day = useAgendaDay(date);
  const pick = (d: string, t: string) => {
    setDate(d);
    setTime(t);
    onChange?.(d, t);
  };
  return <div className="space-y-3" data-id="element-1406" data-mp="6r0gzp3orlty">
      <TimeChoice date={date} onDate={d => pick(d, '')} time={time} onTime={t => pick(date, t)} durationMinutes={durationMinutes} appointments={day.appointments} blocks={day.blocks} ignoreId={ignoreId} overlap={false} onOverlap={() => undefined} allowOverride={false} data-id="element-1407" data-mp="6rsej5guftmv" />
      {day.status === 'error' && <p role="alert" className="text-[13px] text-clay" data-id="element-1408" data-mp="3k4vg6nrj6uly">
          De agenda van deze dag kon niet worden geladen. Kies een andere dag of probeer het zo opnieuw.
        </p>}
      <div className="flex flex-wrap items-center gap-2" data-id="element-1409" data-mp="2rhrhf0j17cim">
        <button type="button" onClick={() => onConfirm(date, time)} disabled={!time || busy || day.status !== 'ready'} aria-busy={busy} className={btnPrimary} data-id="element-1410" data-mp="2rf592yobgszc">
          {busy && <Spinner data-id="element-1411" data-mp="3l55nyv4tsco9" />}
          {time ? confirmLabel(`${dayLong(date)} om ${time}`) : 'Kies een tijd'}
        </button>
        <button type="button" onClick={onCancel} disabled={busy} className={btnGhost} data-id="element-1412" data-mp="3pzi9rbtry036">
          Annuleer
        </button>
      </div>
    </div>;
}